import { RecoilState, useRecoilValue } from "recoil";

export function buildUseRecoilValue<T>(
  // eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
  input: RecoilState<T>
) {
  return function useValue() {
    return useRecoilValue(input);
  };
}
